<template>
  <!-- 路由出口：所有页面的渲染入口，必须保留 -->
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局样式重置，避免默认边距导致布局异常 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  background-color: #f5f5f5;
  font-family: "Microsoft YaHei", sans-serif;
}
</style>